/* Init filtering for the dodatki facet search input (text presentation only). */
(function() {
  function normalizeString(value) {
    return (value || '').toString().toLowerCase().trim();
  }

  function highlightMatch(labelElement, query) {
    if (!labelElement) return;
    var original = labelElement.getAttribute('data-original-label');
    if (!original) {
      original = labelElement.textContent || '';
      labelElement.setAttribute('data-original-label', original);
    }
    if (!query) {
      labelElement.textContent = original;
      return;
    }
    var lowerOriginal = original.toLowerCase();
    var index = lowerOriginal.indexOf(query.toLowerCase());
    if (index === -1) {
      labelElement.textContent = original;
      return;
    }
    var before = original.slice(0, index);
    var match = original.slice(index, index + query.length);
    var after = original.slice(index + query.length);
    labelElement.innerHTML = before + '<b>' + match + '</b>' + after;
  }

  function filterList(input) {
    var fieldset = input.closest('fieldset');
    if (!fieldset) return;
    var list = fieldset.querySelector('ul');
    if (!list) return;
    var query = normalizeString(input.value);
    var showMore = fieldset.querySelector('show-more-button');
    
    // Check if dynamic loading is enabled and not yet loaded
    var filterContainer = input.closest('[data-dynamic-filter="true"]');
    if (filterContainer && !filterContainer.getAttribute('data-dynamic-loaded')) {
      // Wait for dynamic loading to complete
      var checkInterval = setInterval(function() {
        if (filterContainer.getAttribute('data-dynamic-loaded') === 'true') {
          clearInterval(checkInterval);
          filterList(input); // Retry after loading
        }
      }, 100);
      return;
    }

    // When filtering, reveal all items and hide the show-more control
    if (query) {
      if (showMore) showMore.style.display = 'none';
      list.querySelectorAll('li.show-more-item.hidden').forEach(function(li){
        li.classList.remove('hidden');
      });
    } else {
      // Restore show-more state when query is cleared
      if (showMore) showMore.style.display = '';
    }
    var items = list.querySelectorAll('li.facets__item');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      var labelEl = li.querySelector('.facet-checkbox__text-label');
      var text = labelEl ? normalizeString(labelEl.textContent) : '';
      var isMatch = !query || text.indexOf(query) !== -1;
      li.style.display = isMatch ? '' : 'none';
      if (labelEl) highlightMatch(labelEl, query);
    }

    // If query cleared, restore the original hidden class for items beyond the initial threshold
    if (!query) {
      list.querySelectorAll('li.facets__item').forEach(function(li){
        if (li.classList.contains('show-more-item')) {
          li.classList.add('hidden');
        } else {
          li.classList.remove('hidden');
        }
      });
    }
  }

  function onInput(e) {
    var target = e.target;
    if (!target || !target.classList || !target.classList.contains('facet-search-input')) return;
    filterList(target);
  }

  function onKeydown(e) {
    var target = e.target;
    if (!target || !target.classList || !target.classList.contains('facet-search-input')) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  // Attach global listeners (delegated) so it survives re-renders
  document.addEventListener('input', onInput, true);
  document.addEventListener('keydown', onKeydown, true);

  // Initialize immediately for existing inputs
  window.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.facet-search-input').forEach(function(input) {
      filterList(input);
    });
  });
})();


